import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-program-save',
  templateUrl: './program-save.component.html',
  styleUrls: ['./program-save.component.css']
})
export class ProgramSaveComponent implements OnInit {

  constructor() { }

  ngOnInit() {
  }

}



// WEBPACK FOOTER //
// ./src/app/pages-new/Program/program-save/program-save.component.ts